'use client'

import clsx from 'clsx'
import { usePathname } from 'next/navigation'
import React, { memo, MouseEvent, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { selectors } from 'store/selectors'
import { removeCompareItem } from 'store/slices/compare'

import { NotificationMessage } from '@/features/product/NotificationMessage/NotificationMessage'

import { CardData } from '@/entities/card'

import { addToCompare } from '@/shared/lib/utils/compare/addToCompare'
import { IconButton } from '@/shared/ui/IconButton'
import { Toast } from '@/shared/ui/Toast'

import { useIsInComparison } from '../hooks/useIsInComparison'

import cl from './AddToComparison.module.scss'

interface AddToComparisonProps {
	className?: string
	productCode: string
	sectionId: number
	changeCompareIcon?: boolean
	data: CardData
}

export const AddToComparison = memo((props: AddToComparisonProps) => {
	const { className, productCode, sectionId, changeCompareIcon, data } = props
	const pathname = usePathname()
	const dispatch = useDispatch()
	const categories = useSelector(selectors.categoriesItems)
	const isInComparison = useIsInComparison(productCode)
	const isComparePage = pathname.includes(`compare`)
	const [isToastOpen, setIsToastOpen] = useState(false)

	const onClick = (e: MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		e.preventDefault()

		if (isInComparison) {
			dispatch(removeCompareItem({ productKOD: productCode }))
		} else {
			addToCompare(productCode, sectionId, categories, dispatch)
			if (!isComparePage) {
				setIsToastOpen(true)
			}
		}
	}

	const icon = isInComparison && changeCompareIcon ? 'Close' : 'Chart'

	const classes = clsx(cl.root, className, {
		[cl.inComparison]: isInComparison,
		[cl.inComparisonPage]: isInComparison && changeCompareIcon
	})
	const title = isInComparison ? 'Удалить из сравнения' : 'Добавить в сравнение'

	return (
		<>
			<IconButton icon={icon} className={classes} onClick={onClick} title={title} />

			<Toast isOpen={isToastOpen} onClose={() => setIsToastOpen(false)} position="bottom-center" duration={5000}>
				<NotificationMessage
					buttonText="В сравнение"
					imageSrc={data.images[0]}
					link="/compare"
					text={data.title}
					mobileButtonText="Перейти"
					mobileText="Товар добавлен в сравнение"
				/>
			</Toast>
		</>
	)
})
